import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ReactParser from 'react-html-parser';
import * as routes from '../../../../constants/routes';
import { convertDateToReadableFormat } from '../../../../app/functions';
import Tag from '../../../../components/common/shared/tag';
import questionIcon from '../../../../assets/icons/question-icon.svg';
import answerIcon from '../../../../assets/icons/answer-icon.svg';
import './index.scss';

const HTML_REGEX = /(<([^>]+)>)/ig;

const CONTENT_WORDS_LIMIT = 20;

const QuestionResult = ({ legalAdvicePage, data }) => {
    const translations = useSelector((store) => store.config.Translations);

    /**
     * Used to limit the number of words displayed in question/answer content.
     *
     * @param {string} fullContent
     * @return {string}
     */
    const limitWords = (fullContent) => {
        const wordsList = fullContent.split(/\s+/);

        if (wordsList.length > CONTENT_WORDS_LIMIT) {
            return wordsList.splice(0, CONTENT_WORDS_LIMIT).join(' ') + '...';
        }

        return fullContent;
    };

    return (
        <Link
            to={routes.legal_advice + routes.legal_advice_routes.view_question + `/${data.id}`}
            className="legal-advice-question-result"
        >
            <div className="question-content-container">
                <img
                    src={questionIcon}
                    alt="Question Icon"
                    className="side-icon"
                />

                <p className="question-content">
                    <span className="content-title">
                        {translations['legal_advice_view_question_question_subtitle']}
                    </span>

                    {ReactParser(limitWords(data.question_content.replace(HTML_REGEX, '')))}
                </p>
            </div>

            <div className="answer-content-container">
                <img
                    src={answerIcon}
                    alt="Answer Icon"
                    className="side-icon"
                />

                <p className="answer-content">
                    <span className="content-title">
                        {translations['legal_advice_view_question_answer_subtitle']}
                    </span>

                    {ReactParser(limitWords(data.answer_content.replace(HTML_REGEX, '')))}
                </p>
            </div>

            {data.linked_tags.length > 0 &&
                <div className="question-tags">
                    {data.linked_tags.map((tagId) => {
                        const tagData = legalAdvicePage.tags.find((tag) => tag.id === tagId);

                        return tagData && (
                            <Tag key={tagData.id} data={tagData} />
                        );
                    })}
                </div>
            }

            <p className="question-date">
                {convertDateToReadableFormat(data.created_at * 1000)}
            </p>
        </Link>
    );
};

export default QuestionResult;
